// Event-firing snippet, raw HTTP. Mirrors the /events edge function
// contract so engineers on any engine can port from here.

export function buildEventHttpSnippet(apiKey: string, functionsBaseUrl: string): string {
  return `# PlayerBase event firing - raw HTTP / bash
# Companion recipe to the pairing snippet above. Lift it into any
# platform that can sign a body with HMAC-SHA256 and POST JSON.
# EVENT_NAME must match one of the SDK event names you configured on
# the playtest flow (case-sensitive).
#
# Call from anywhere in your game:
#
#   ./fire.sh tutorialComplete
#   PAYLOAD='{"boss":"stage1","tries":4}' ./fire.sh bossDefeated
#
# Behaviour:
#   * No-op until the player has paired - skip the call locally if
#     PLAYER_TOKEN is empty so unpaired installs stay silent.
#   * Generates a fresh idempotencyKey per fire, so retries collapse
#     server-side instead of double-counting.
#   * 200 covers ok / duplicate / no_active_playtest - all expected
#     during normal operation. Anything else surfaces the error JSON
#     so config drift in dev builds is visible (the script keeps
#     running so gameplay isn't affected).
#
# Requires: bash, curl, openssl, uuidgen.

set -euo pipefail

API_KEY="${apiKey}"
PLAYER_TOKEN="\${PLAYER_TOKEN:-PASTE_TOKEN_HERE}"
EVENT_NAME="\${1:-tutorialComplete}"
PAYLOAD="\${PAYLOAD:-{}}"
IDEMPOTENCY_KEY=$(uuidgen | tr 'A-Z' 'a-z')
OCCURRED_AT=$(date -u +"%Y-%m-%dT%H:%M:%SZ")

# Unquoted heredoc terminator so variable expansion happens inline. The
# body bytes here are what we sign and what we send - keep them in sync.
BODY=$(cat <<JSON
{"playerToken":"$PLAYER_TOKEN","eventName":"$EVENT_NAME","idempotencyKey":"$IDEMPOTENCY_KEY","payload":$PAYLOAD,"occurredAt":"$OCCURRED_AT"}
JSON
)

SIGNATURE=$(printf '%s' "$BODY" | openssl dgst -sha256 -hmac "$API_KEY" -binary | xxd -p -c 256)

curl -sS -X POST ${functionsBaseUrl}/events \\
  -H "content-type: application/json" \\
  -H "x-playerbase-signature: $SIGNATURE" \\
  --data-binary "$BODY"

# Success: 200 { "status": "ok" | "duplicate" | "no_active_playtest", ... }
# Errors:  401 missing_signature | invalid_signature | not_configured | invalid_token
#
# Notes:
#   * --data-binary keeps the bytes byte-exact, so the signature matches.
#   * PAYLOAD must be valid JSON. Examples:
#       PAYLOAD='{"level":4}'              ./fire.sh bossDefeated
#       PAYLOAD='{}'                       ./fire.sh tutorialComplete
`;
}
